import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

const Robustand = () => {
  return (
    <div className="Robustand p-100">
        <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
                        <h2>Experts In Wearable App Development Services</h2>
                        <p>Wearable app spending will grow to $63 billion in 2021, registering double digit growth from just $32.5 billion in 2018. The market grew twice in size in just three years, making it perhaps one of the most lucrative avenues to invest in the field of app development.</p>
                        <Link to="/contact"
                                  className="border_btn dark_btn" aria-label="TekRevol Contact">Let’s Get Started</Link>
                    </Col>
                    <Col xs={12} md={6} lg={7} xl={6} xxl={6} className="offset-xl-1">
                        <div className="robustscroll">
                        <div className="robust-box">
                            <div className="robust-content">
                                <h4>Android Wearable App Development</h4>
                                <p>We ensure that we make full use of the phenomenal dexterity and range of devices offered by the Android OS in our wearable app development services.</p>
                                <p>Through custom wearable app development services, our team pulls of all types of projects in the Android Wear Apps niche.</p>
                                <p>Recognized across the industry, we’ve built some incredible wearable apps for a wide variety of functionalities ranging from fitness trackers to health monitors and many more.</p>
                            </div>
                            <div className="robust-content">
                                <h4>iWatch App Development Services</h4>
                                <p>We know that Apple users are the most demanding and yet the most loyal customers out there. Our wearable app development services caters to this audience with visually engaging and platform centric apps that are perfect to use for all purposes.</p>
                            </div>
                        </div>
                        </div>
                    </Col>
                </Row>
            </Container>
    </div>
  )
}

export default Robustand